import useReveal from '../../hooks/useReveal';

const HOME_STORY_BG =
  'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=80';

const HomeStorySection = () => {
  const [ref, visible] = useReveal();

  return (
    <section
      ref={ref}
      className="home-story"
      style={{ backgroundImage: `url(${HOME_STORY_BG})` }}
      aria-labelledby="home-story-heading"
    >
      <div className="home-story-wrap">
        <div className="home-story-inner">
          <div className={`reveal-up ${visible ? 'visible' : ''} home-story-eyebrow`}>
            <div className="home-story-eyebrow-line" aria-hidden="true"></div>
            <span className="home-story-eyebrow-text">Fractional access</span>
          </div>

          <h2
            id="home-story-heading"
            className={`reveal-up delay-1 ${visible ? 'visible' : ''} home-story-title`}
          >
            At CoOwn, invest from <em>$500</em> in real estate projects reviewed by our team
          </h2>

          <p className={`reveal-up delay-2 ${visible ? 'visible' : ''} home-story-lead`}>
            We pool capital from many investors so more people can access fractional real estate.
          </p>

          <p className={`reveal-up delay-3 ${visible ? 'visible' : ''} home-story-copy`}>
            Your investment makes you a participant in the project, with transparent offering details,
            milestones, and returns aligned to each listing. This is more than a grid of properties.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HomeStorySection;
